export const Top7 = () => {
    return (
        <svg width="83" height="100" viewBox="0 0 83 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M78.6851 1.84692L77.2262 11.4022L26.4954 98.4615H9.38623L59.8517 14.5873H11.7072L13.763 1.84692H78.6851Z"
                fill="url(#paint0_linear_1283_103)"
                fillOpacity="0.4"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1283_103"
                    x1="9.38623"
                    y1="47.046"
                    x2="89.6977"
                    y2="47.046"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="0.763542" stopColor="white" stopOpacity="0" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
